<template>
    <div class="tw-w-4/5">
        <h4 class="tw-font-neue-kabel-bold !tw-text-[64px] tw-text-[#FF0090] !tw-mb-6">Thanks for Joining Ezi!</h4>
        <p class="tw-text-[1.2em] tw-leading-tight">
            You’ll receive an order confirmation email shortly with further details regarding your connection. You can
            now close this browser.
        </p>

        <a href="/#/signup">Do you want to order again?</a>
    </div>
</template>
